<template>
  <div id="app">
    <AppHeader></AppHeader>
    <router-view />
    <AppFooter></AppFooter>
  </div>
</template>

<script>
// 引入头部和尾部组件
import AppHeader from "./components/Header.vue"
import AppFooter from "./components/footer.vue"
export default {
  name: 'App',
  components: {
    AppHeader,
    AppFooter
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/App.vue